<div class="po-row po-mt-4">
    <po-button-group [p-buttons]="buttons"></po-button-group>
    <po-button-group [p-buttons]="newButtons"></po-button-group>
    <span class="azul-thf"><strong>{{currentPage}} / {{totalPages}}</strong></span>
    
</div>